<template>
  <div>
    <v-row justify="center" align="start" class="mt-0">
      <v-col cols="12" md="12" sm="12" v-if="$store.getters.retrieveAnon">
        <ChangePostcode />
      </v-col>

      <v-col cols="12" md="12" xs="12" class="py-0" v-if="!retrieveGuest">
        <DateAlert></DateAlert>
      </v-col>

      <v-col cols="12" class="ma-0"><CutOff /></v-col>

      <v-col cols="12" md="12" xs="12" class="py-0" v-if="!retrieveGuest">
        <MandatoryCategory
          @getMandatoryCat="getMandatoryCat()"
          :isStandingOrder="false"
        ></MandatoryCategory>
      </v-col>

      <v-col cols="12" md="12" xs="12">
        <v-row justify="start" align="start" no-gutters ref="searchTop">
          <v-col cols="12" md="12" xs="12" class="hidden-md-and-down">
            <v-row justify="space-between" align="start">
              <v-col class="pt-0">
                <v-btn
                  :loading="loadingGroup"
                  block
                  outlined
                  color="blue darken-2"
                  :to="{ name: 'OrdersSearchGroups' }"
                >
                  <v-icon left>mdi-group</v-icon>View by Group
                </v-btn>
              </v-col>
              <v-col
                class="pt-0"
                v-if="
                  !$store.getters.retrieveGuest && !$store.getters.retrieveAnon
                "
              >
                <v-btn
                  :loading="loadingFavourites"
                  block
                  outlined
                  color="favourites"
                  @click="getFavouriteProducts()"
                >
                  <v-icon left>mdi-heart</v-icon>
                  {{ favouritesText }}
                </v-btn>
              </v-col>
              <v-col v-if="showPromotionsButton" class="pt-0">
                <v-btn
                  :loading="loadingPromotions"
                  block
                  outlined
                  color="promotions"
                  @click="getPromotionalProducts()"
                >
                  <v-icon left>mdi-sale</v-icon>{{ promoBtnText }}
                </v-btn>
              </v-col>
              <v-col v-if="showNewProdsButton" class="pt-0">
                <v-btn
                  :loading="loadingNewProducts"
                  block
                  outlined
                  color="green darken-2"
                  @click="getNewlyAvailableProducts()"
                >
                  <v-icon left>fiber_new</v-icon>New Products
                </v-btn>
              </v-col>
              <v-col
                class="pt-0"
                v-if="
                  !$store.getters.retrieveGuest && !$store.getters.retrieveAnon
                "
              >
                <v-btn
                  block
                  outlined
                  color="purple base"
                  :to="{ name: 'OrdersSearchTemplates' }"
                >
                  <v-icon left>mdi-format-list-checkbox</v-icon>Templates
                </v-btn>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="12" xs="12" class="mt-4">
            <v-row justify="space-between" align="start">
              <v-col cols="9" md="5" sm="7" class="pb-0">
                <v-form ref="searchForm" @submit.prevent="userSearchProduct">
                  <v-text-field
                    :loading="
                      $store.getters['orderSearch/retrieveLoadingSearch']
                    "
                    v-model="search"
                    ref="search"
                    :rules="searchRules"
                    placeholder="Product Search"
                    filled
                    clearable
                    @input="debounceSearch"
                    :error-messages="searchErrors"
                  >
                    <template slot="append">
                      <v-btn
                        icon
                        class="mr-0 ml-2 mb-1 p-0"
                        style="margin-top: -6px"
                        @click="userSearchProduct()"
                      >
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-form>
              </v-col>

              <v-col v-if="enableFilters" cols="3" md="3" sm="3" class="pb-0">
                <v-btn-toggle
                  v-model="showFilters"
                  borderless
                  style="width: 100%"
                >
                  <v-spacer></v-spacer>
                  <v-btn v-if="showFilters" :value="false" block height="56px">
                    <v-icon :left="$vuetify.breakpoint.smAndUp"
                      >mdi-filter-remove-outline</v-icon
                    >
                    <span class="hidden-xs-only">Hide Filters</span>
                  </v-btn>

                  <v-btn v-else :value="true" block height="56px">
                    <v-icon :left="$vuetify.breakpoint.smAndUp"
                      >mdi-filter-outline</v-icon
                    >
                    <span class="hidden-xs-only">Show Filters</span>
                  </v-btn>
                </v-btn-toggle>
              </v-col>
            </v-row>

            <v-row justify="space-between" align="start">
              <v-col cols="12" class="pt-0">
                <v-row justify="space-between" align="start" no-gutters>
                  <v-col class="text--secondary">
                    <div v-if="filteredProds.length">
                      {{ filteredProds.length }} Product<span
                        v-if="filteredProds.length > 1"
                        >s</span
                      >
                      Found

                      <!-- <span
                        v-if="$store.getters['orderSearch/retrieveSearchType']"
                      >
                        in
                        {{ $store.getters["orderSearch/retrieveSearchType"] }}
                      </span> -->
                      <span
                        v-if="$store.getters['orderSearch/retrieveSearchType']"
                      >
                        in
                        <span v-if="isShowingCategories" class="red--text">
                          <router-link
                            :to="{
                              name: 'OrdersSearchGroupCategories',
                              params: { id: retrieveSelectedGroup.group_no },
                            }"
                          >
                            {{
                              $store.getters["orderSearch/retrieveSearchType"]
                            }}
                          </router-link>
                        </span>
                        <span v-else>
                          {{ $store.getters["orderSearch/retrieveSearchType"] }}
                        </span>
                      </span>
                    </div>
                  </v-col>
                  <v-col
                    class="text--secondary"
                    style="text-align: right"
                    v-if="pages"
                  >
                    Page {{ currentPage }} of {{ pages }}
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" lg="3" md="12" class="pa-0" v-if="enableFilters">
                <v-card
                  v-if="showFilters"
                  class="mx-auto"
                  tile
                  flat
                  color="background"
                >
                  <v-navigation-drawer
                    floating
                    v-model="showFilters"
                    :app="!$vuetify.breakpoint.lgAndUp"
                    color="background"
                  >
                    <v-list nav expand>
                      <v-subheader>
                        <v-list-item-content>
                          <v-list-item-title class="h6">
                            <v-icon left>mdi-filter-outline</v-icon>Product
                            Filters
                          </v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action
                          @click="showFilters = false"
                          class="hidden-lg-and-up"
                        >
                          <v-icon>clear</v-icon>
                        </v-list-item-action>
                      </v-subheader>
                      <v-btn
                        class="my-2"
                        block
                        outlined
                        color="error"
                        @click="
                          currentPage = 1;
                          resetFilters();
                        "
                        :disabled="
                          distributorFilters == 0 &&
                          productFilters.length == 0 &&
                          categoryFilters.length == 0
                        "
                        >Reset Filters</v-btn
                      >

                      <v-list-group
                        v-if="hasValidDistributorFilters"
                        color="blue darken-2"
                        prepend-icon="local_shipping"
                        v-model="showDistributors"
                      >
                        <template v-slot:activator>
                          <v-list-item-title>Distributors</v-list-item-title>
                        </template>

                        <v-radio-group v-model="distributorFilters">
                          <v-radio :value="0" color="blue darken-2">
                            <template v-slot:label>
                              <div>All</div>
                            </template>
                          </v-radio>

                          <v-radio
                            v-for="(filter, index) in $store.getters[
                              'retrieveDistributorsAvailable'
                            ]"
                            :key="index"
                            :value="parseInt(filter.number)"
                            color="blue darken-2"
                          >
                            <template v-slot:label>
                              <div>{{ filter.name }}</div>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </v-list-group>

                      <v-list-group
                        v-if="hasValidProductFilter"
                        color="blue darken-2"
                        prepend-icon="filter_list"
                        v-model="showGeneral"
                      >
                        <template v-slot:activator>
                          <v-list-item-title>General</v-list-item-title>
                        </template>

                        <v-list-item-group
                          v-model="productFilters"
                          color="blue darken-2"
                          multiple
                        >
                          <div
                            v-for="(filter, index) in generalFilters"
                            :key="index"
                          >
                            <v-list-item
                              v-if="filtersAvailable[filter.flag]"
                              @click="currentPage = 1"
                              :label="filter.title"
                              :value="filter.value"
                              class="mb-1"
                            >
                              <template v-slot:default="{ active }">
                                <v-list-item-action>
                                  <v-checkbox
                                    :input-value="active"
                                    color="blue darken-2"
                                  >
                                    <template v-slot:append>
                                      <v-img
                                        contain
                                        width="24px"
                                        height="24px"
                                        :src="filter.image"
                                        style="max-width: 24px"
                                      />
                                    </template>
                                  </v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                  <v-list-item-title>{{
                                    filter.title
                                  }}</v-list-item-title>
                                </v-list-item-content>
                              </template>
                            </v-list-item>
                          </div>
                        </v-list-item-group>
                      </v-list-group>

                      <v-list-group
                        v-if="hasValidCategoryFilter"
                        prepend-icon="category"
                        v-model="showCategory"
                        color="blue darken-2"
                      >
                        <template v-slot:activator>
                          <v-list-item-title>Categories</v-list-item-title>
                        </template>

                        <v-list-item-group
                          color="blue darken-2"
                          v-model="categoryFilters"
                          multiple
                        >
                          <v-list-item
                            v-for="category in currentlySelectedGroup.categories"
                            :key="category.category_no"
                            @click="currentPage = 1"
                            :label="category.category_description"
                            :value="category.category_no"
                            class="mb-1"
                          >
                            <template v-slot:default="{ active }">
                              <v-list-item-action>
                                <v-checkbox
                                  :input-value="active"
                                  color="blue darken-2"
                                ></v-checkbox>
                              </v-list-item-action>

                              <v-list-item-content>
                                <v-list-item-title>{{
                                  category.category_description
                                }}</v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list-group>
                    </v-list>
                  </v-navigation-drawer>
                </v-card>
              </v-col>

              <v-col
                cols="12"
                :lg="!enableFilters ? false : showFilters ? 9 : 12"
                md="12"
                xs="12"
                class="pa-0"
              >
                <v-chip
                  class="ma-2"
                  filter
                  v-for="(product, index) in productFilters"
                  :key="index"
                  style="text-transform: capitalize"
                  >{{ product }}</v-chip
                >

                <!-- <v-chip
                  class="ma-2"
                  filter
                  v-for="(category, index) in categoryFilters"
                  :key="index"
                  style="text-transform: capitalize;"
                >{{category}}</v-chip>-->

                <v-layout v-if="isProdGrid" row wrap justify-start>
                  <ProductGrid
                    v-for="product in filteredPage"
                    :key="product.prod_no"
                    v-bind:product="product"
                    v-bind:visible="true"
                    :showFilters="!enableFilters ? false : showFilters"
                  ></ProductGrid>
                </v-layout>
                <v-layout v-else row wrap justify-start>
                  <ProductList
                    v-for="product in filteredPage"
                    :key="product.prod_no"
                    v-bind:product="product"
                    v-bind:visible="true"
                  ></ProductList>
                </v-layout>
              </v-col>

              <v-col cols="12" xs="12" class="pa-0">
                <v-pagination
                  v-if="filteredProds.length > 0"
                  v-model="currentPage"
                  :length="pages"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                  color="blue darken-2"
                  @input="scrollToSearch()"
                ></v-pagination>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-bottom-navigation
      app
      fixed
      color="blue darken-2"
      class="hidden-lg-and-up"
    >
      <v-btn @click="focusSearch()">
        <span>Search</span>
        <v-icon>mdi-magnify</v-icon>
      </v-btn>

      <v-btn :to="{ name: 'OrdersSearchGroups' }" @click="scrollToTop()">
        <span>Groups</span>
        <v-icon>mdi-group</v-icon>
      </v-btn>

      <v-btn
        v-if="!$store.getters.retrieveGuest && !$store.getters.retrieveAnon"
        :loading="loadingFavourites"
        @click="
          getFavouriteProducts();
          scrollToSearch();
        "
      >
        <span>Faves</span>
        <v-icon>mdi-heart</v-icon>
      </v-btn>

      <v-btn
        v-if="showPromotionsButton && !$store.getters.retrieveAnon"
        :loading="loadingPromotions"
        @click="
          getPromotionalProducts();
          scrollToSearch();
        "
      >
        <span>{{
          promoBtnText == "Promotions" ? "Promos" : promoBtnText
        }}</span>
        <v-icon>mdi-sale</v-icon>
      </v-btn>

      <v-btn
        v-if="showNewProdsButton"
        :loading="loadingNewProducts"
        @click="
          getNewlyAvailableProducts();
          scrollToSearch();
        "
      >
        <span>New</span>
        <v-icon>fiber_new</v-icon>
      </v-btn>

      <v-btn
        v-if="!$store.getters.retrieveGuest && !$store.getters.retrieveAnon"
        :to="{ name: 'OrdersSearchTemplates' }"
        @click="scrollToTop()"
      >
        <span>Templates</span>
        <v-icon>mdi-format-list-checkbox</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";

import ProductGrid from "@/components/order/search/ProductGrid.vue";
import ProductList from "@/components/order/search/ProductList.vue";
import MandatoryCategory from "@/components/order/MandatoryCategory.vue";
import CutOff from "@/components/order/Cutoff.vue";

import DateAlert from "@/components/order/DateAlert.vue";
import ChangePostcode from "@/components/auth/anon/ChangePostcode.vue";

export default {
  name: "ProductSearch",

  props: ["category"],

  components: {
    ProductGrid,
    ProductList,
    MandatoryCategory,
    CutOff,
    DateAlert,
    ChangePostcode,
  },
  data() {
    return {
      productGrid: this.$store.getters.retrieveProductGrid,
      loadingGroup: false,
      loadingFavourites: false,
      loadingPromotions: false,
      loadingNewProducts: false,

      showDistributors: true,
      showGeneral: true,
      showCategory: true,

      showFilters: this.$store.getters.retrieveProductFilters,

      filtersAvailable: {
        nut_coeliacs_flag: false,
        nut_diabetics_flag: false,
        nut_fair_trade_certified_flag: false,
        nut_halal_certified_flag: false,
        nut_kosher_certified_flag: false,
        nut_leaf_certified_flag: false,
        nut_local_certified_flag: false,
        nut_organic_certified_flag: false,
        nut_red_tractor_certified_flag: false,
        nut_uk_certified_flag: false,
        nut_vegans_flag: false,
        nut_vegetarians_flag: false,
      },

      generalFilters: [
        {
          value: "vegetarian",
          flag: "nut_vegetarians_flag",
          image: require("@/assets/filters/vegetarian.png"),
          title: "Vegetarian",
        },
        {
          value: "vegan",
          flag: "nut_vegans_flag",
          image: require("@/assets/filters/vegan.png"),
          title: "Vegan",
        },
        {
          value: "glutenFree",
          flag: "nut_coeliacs_flag",
          image: require("@/assets/filters/glutenFree.jpg"),
          title: "Gluten Free",
        },

        {
          value: "coeliac",
          flag: "nut_coeliacs_flag",
          image: require("@/assets/filters/coeliac.jpg"),
          title: "Coeliac",
        },

        {
          value: "fairTrade",
          flag: "nut_fair_trade_certified_flag",
          image: require("@/assets/filters/fairTrade.png"),
          title: "Fair Trade",
        },

        {
          value: "uk",
          flag: "nut_uk_certified_flag",
          image: require("@/assets/filters/uk.png"),
          title: "UK",
        },

        {
          value: "local",
          flag: "nut_local_certified_flag",
          image: require("@/assets/filters/local.jpg"),
          title: "Local",
        },

        {
          value: "redTractor",
          flag: "nut_red_tractor_certified_flag",
          image: require("@/assets/filters/redTractor.png"),
          title: "Red Tractor",
        },

        {
          value: "halal",
          flag: "nut_halal_certified_flag",
          image: require("@/assets/filters/halal.png"),
          title: "Halal",
        },

        {
          value: "kosher",
          flag: "nut_kosher_certified_flag",
          image: require("@/assets/filters/kosher.png"),
          title: "Kosher",
        },
      ],

      //  distributorFilters: 0,
      productFilters: [],
      categoryFilters: [],

      search: "",
      searchRules: [
        //v => !!v || "Search can't be ",
        (v) =>
          (v &&
            v.length >= this.$store.getters.retrieveMinimumSearchCharacters &&
            v.length > 0) ||
          "Search must be at least " +
            this.$store.getters.retrieveMinimumSearchCharacters +
            " characters",
        (v) => /^[a-zA-Z0-9 ]*$/.test(v) || "Search must be alphanumeric only",
      ],
      searchErrors: [],
    };
  },

  async beforeMount() {
    console.log("-- Before Mount");

    if (this.checkValidBasket()) {
      console.log("-- URL nonsense 1");
      console.log(this.page);

      console.log(" -- Checking Order Date");
      this.setAutoload(true);

      // this.clearProducts();

      console.log(this.$store.getters.retrieveCurrentTrolly);
    }
  },

  mounted() {
    console.log("-- Get Filters Available");
    this.getFiltersAvailable();
    console.log("-- Finding Distributors 1");
    this.getDistributors();
  },

  activated() {
    //Check if we have a valid troll before we let the user access this route
    if (this.checkValidBasket()) {
      //Set the Page in the URL
      this.$router
        .push({
          name: "OrdersSearch",
          query: {
            page: parseInt(this.$store.getters["orderSearch/retrievePage"]),
          },
        })
        .catch((err) => {
          console.log(err);
        });

      this.checkAutoLoad();

      //To change -- Only get these if we don't already have them
      // this.getFiltersAvailable();
      // this.getDistributors();
    }
  },

  watch: {
    $route(to, from) {
      // react to route changes...
      // console.log("-- Route Watch");
      // console.log(to);
      // console.log(from);

      // console.log("-- Page Number");
      // console.log(to.query.page);
      let newQueryPageNumber =
        parseInt(to.query.page) ||
        this.$store.getters["orderSearch/retrievePage"];

      this.setPage(newQueryPageNumber);
    },

    retrievePage: function (val) {
      // console.log("-- Retrieve Page Value Updated");
      // console.log(val);

      this.$router
        .push({
          name: "OrdersSearch",
          query: { page: parseInt(val) },
        })
        .catch((err) => {
          console.log(err);
        });
    },

    orderDate: async function (val) {
      // console.log("-- Order Date Changed");
      // console.log(val);
      this.clearProducts();
      //To do
    },

    showFilters(to, from) {
      console.log("-- Show Filters Changed");
      console.log("  -- Checking if our current page is > last page");
      console.log(this.currentPage);
      console.log(this.pages);
      console.log("-- Stop");
      if (this.currentPage > this.pages) {
        this.currentPage = this.pages;
      }
    },
  },

  computed: {
    ...mapGetters(["retrieveGuest", "isCategoriesShowEnabled"]),
    ...mapGetters("orderSearch", ["retrievePage", "retrieveSelectedGroup"]),

    distributorFilters: {
      get() {
        return this.$store.state.customer.selectedDistributor;
      },
      set(val) {
        this.$store.commit("setSelectedDistributor", val);
      },
    },

    promoBtnText() {
      let btnText = "PROMOTIONS";
      if (
        this.$store.getters.retrieveAllConfigs.promo_btn_text &&
        this.$store.getters.retrieveAllConfigs.promo_btn_text != ""
      ) {
        btnText = this.$store.getters.retrieveAllConfigs.promo_btn_text;
      }
      return btnText;
    },

    enableFilters() {
      //Check if we have any valid filters available for selection
      console.log("-- Enable Filters checks");
      console.log(this.hasValidProductFilter);
      console.log(this.hasValidCategoryFilter);
      console.log(this.hasValidDistributorFilters);
      console.log("-- End Checks");

      if (
        this.hasValidProductFilter ||
        this.hasValidCategoryFilter ||
        this.hasValidDistributorFilters
      ) {
        //We do so enable the filters
        console.log("-- ENABLE FILTERS");
        return true;
      }

      //We do not so hide it
      console.log("-- DISABLE FILTERS");
      return false;
    },

    hasValidProductFilter() {
      for (var element of this.generalFilters) {
        if (this.filtersAvailable[element.flag] == true) {
          return true;
        }
      }

      return false;
    },

    hasValidCategoryFilter() {
      if (this.currentlySelectedGroup) {
        if (this.currentlySelectedGroup.categories.length > 0) {
          return true;
        }
      }

      return false;
    },

    // hasValidDistributorFilters() {
    //   //Only be true if we have multiple available
    //   if (
    //     this.$store.getters["retrieveDistributorsAvailable"].length > 1 &&
    //     this.$store.getters.retrieveShowDistributorFilters
    //   ) {
    //     return true;
    //   }

    //   return false;
    // },

    hasValidDistributorFilters() {
      return this.$store.getters.isDistFilterEnabled;
    },

    currentlySelectedGroup() {
      if (this.$store.getters["orderSearch/retrieveSelectedGroup"] != false) {
        if (
          this.$store.getters["orderSearch/retrieveSelectedGroup"]
            .group_filter == "1"
        ) {
          return this.$store.getters["orderSearch/retrieveSelectedGroup"];
        } else {
          return false;
        }
      }
      return false;
    },

    showPromotionsButton() {
      let show = true;

      console.log("-- Show Promo?");
      console.log(this.$store.getters.retrieveAllConfigs.prom_show);

      if (this.$store.getters.retrieveCustomer) {
        if (
          this.$store.getters.retrieveAllConfigs.prom_show == 0 ||
          parseInt(
            this.$store.getters.retrieveCustomer.customer.ignore_promotions
          ) == 1
        ) {
          show = false;
        }
      } else {
        show = false;
      }

      return show;
    },

    showNewProdsButton() {
      let show = true;

      if (this.$store.getters.retrieveAllConfigs.new_products_show == 0) {
        show = false;
      }

      return show;
    },

    orderDate() {
      if (this.$store.getters.retrieveCurrentTrolly) {
        return this.$store.getters.retrieveCurrentTrolly.order_date;
      } else {
        return null;
      }
    },

    favouritesText() {
      return "Favourites";
    },

    currentPage: {
      get() {
        return parseInt(this.$store.getters["orderSearch/retrievePage"]) || 1;
      },
      set(value) {
        console.log("-- Page Changing");
        this.setPage(parseInt(value));
      },
    },

    // currentPage: {
    //   get() {
    //     console.log("-- Page Getting");
    //     return (
    //       parseInt(this.$route.query.page) || this.$store.getters.retrievePage
    //     );
    //   },
    //   set(value) {
    //     console.log("-- Page Changing");
    //     console.log(value);

    //     this.setPage(parseInt(value));

    //     this.$router
    //       .push({
    //         name: "OrdersSearch",
    //         query: { page: parseInt(value) }
    //       })
    //       .catch(err => {
    //         console.log(err);
    //       });
    //   }
    // },

    isProdGrid() {
      if (this.$store.getters.retrieveProductGrid) {
        return true;
      } else {
        return false;
      }
    },

    filteredProds() {
      return this.$store.getters["orderSearch/retrieveProducts"].filter(
        this.filterProducts
      );
    },

    filteredPage() {
      let originalFilter = this.filteredProds.slice(
        (this.currentPage - 1) * this.pageLength,
        this.currentPage * this.pageLength
      );

      return originalFilter;
    },

    pages() {
      return this.pageLength
        ? Math.ceil(this.filteredProds.length / this.pageLength)
        : 0;
    },

    pageLength() {
      let prodsPerPage = 15;
      if (this.$store.getters.retrieveAllConfigs.orders_products_per_page) {
        prodsPerPage = parseInt(
          this.$store.getters.retrieveAllConfigs.orders_products_per_page
        );
      }

      //This is our base products per page
      // -- But we want to tweak this based on our page size to fit evenly
      console.log("-- Prods Per Page");
      console.log(prodsPerPage);
      console.log(this.$vuetify.breakpoint.name);

      let prodsPerRow = 5;
      //lg2 md3 sm4 xs6

      //Need to take into account if the filters are showing too...

      switch (this.$vuetify.breakpoint.name) {
        case "lg":
          if (this.showFilters) {
            prodsPerRow = 4;
          } else {
            prodsPerRow = 5;
          }

          break;

        case "md":
          prodsPerRow = 4;
          break;

        case "sm":
          prodsPerRow = 3;
          break;

        case "xs":
          prodsPerRow = 2;
          break;
      }

      console.log(prodsPerRow);
      console.log("-- Remainder");
      let remainder = prodsPerPage % prodsPerRow;
      console.log(remainder);
      prodsPerPage -= remainder;

      return prodsPerPage;
    },

    distributorsAvalable() {
      return this.$store.getters["retrieveDistributorsAvailable"];
    },

    isShowingCategories() {
      if (this.isCategoriesShowEnabled) {
        return true;
      }
      return false;
    },
  },

  methods: {
    ...mapActions(["getDistributors"]),

    ...mapActions("orderSearch", [
      "setPage",
      "setAutoload",
      "setGroups",
      "clearProducts",
      "productSearch",
      "getCatPriceList",
      "getMandatoryCategory",
      "getGroupPriceList",
      "getFavourites",
      "getPromotions",
      "getNewProducts",
    ]),

    checkValidBasket() {
      if (
        this.$store.getters.retrieveCurrentTrolly == false &&
        !this.$store.getters.retrieveGuest
      ) {
        this.$router.replace({ name: "OrdersCreate" });
        return false;
      } else {
        return true;
      }
    },

    checkAutoLoad() {
      console.log("-- Checking Autoload");

      console.log(this.$store.getters["orderSearch/retrieveAutoload"]);

      if (this.$store.getters["orderSearch/retrieveAutoload"]) {
        switch (
          parseInt(
            this.$store.getters.retrieveAllConfigs.orders_autoload_favourites
          )
        ) {
          case 1:
            console.log("-- Autoload Favourites");
            this.getFavouriteProducts();
            break;

          case 2:
            console.log("-- Autoload Groups");
            console.log(
              this.$store.getters.retrieveAllConfigs
                .orders_autoload_group_number
            );

            if (
              parseInt(
                this.$store.getters.retrieveAllConfigs
                  .orders_autoload_group_number
              )
            ) {
              this.getGroup(
                parseInt(
                  this.$store.getters.retrieveAllConfigs
                    .orders_autoload_group_number
                )
              );
            } else {
              //Go to the groups page
              this.$router.push({ name: "OrdersSearchGroups" });
            }

            break;

          case 3:
            this.getPromotionalProducts();
            break;

          case 4:
            this.getNewlyAvailableProducts();
            break;
        }

        this.setAutoload(false);
      }
    },

    filterProducts(product) {
      let productFilters = this.productFilters;

      //Default our product to show
      var showProduct = true;

      if (productFilters.includes("vegetarian")) {
        if (product.vegetarian != true) {
          showProduct = false;
        }
      }

      if (productFilters.includes("vegan")) {
        if (product.vegan != true) {
          showProduct = false;
        }
      }

      if (productFilters.includes("glutenFree")) {
        if (product.glutenFree != true) {
          showProduct = false;
        }
      }

      if (productFilters.includes("coeliac")) {
        if (product.coeliac != true) {
          showProduct = false;
        }
      }

      if (productFilters.includes("fairTrade")) {
        if (product.fairTrade != true) {
          showProduct = false;
        }
      }

      if (productFilters.includes("uk")) {
        if (product.uk != true) {
          showProduct = false;
        }
      }

      if (productFilters.includes("local")) {
        if (product.local != true) {
          showProduct = false;
        }
      }

      if (productFilters.includes("redTractor")) {
        if (product.redTractor != true) {
          showProduct = false;
        }
      }

      if (productFilters.includes("kosher")) {
        if (product.kosher != true) {
          showProduct = false;
        }
      }

      if (productFilters.includes("halal")) {
        if (product.halal != true) {
          showProduct = false;
        }
      }

      if (this.distributorFilters != 0) {
        if (this.distributorFilters != parseInt(product.distributor_no)) {
          showProduct = false;
        }
      }

      if (this.categoryFilters.length > 0) {
        if (this.categoryFilters.includes(product.product_category) == 0) {
          showProduct = false;
        }
      }

      return showProduct;
    },

    debounceSearch() {
      // If Config > 0
      if (this.$store.getters.retrieveMinimumSearchConfig > 0) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
          console.log(this.search);
          this.userSearchProduct();
        }, 600);
      }
    },

    async getFiltersAvailable() {
      let stringPayload = JSON.stringify({
        userId: this.$store.getters.retrieveUser.userNum,
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
        customerNo: this.$store.getters.retrieveSelectedCustomer,
      });
      const params = new URLSearchParams();
      params.append("params", stringPayload);

      console.log("Get Filters Available");

      await axios
        .post("get-certified-icons", params)
        .then((response) => {
          console.log("-- Certified Icons");
          console.log(response.data);

          if (response.data.success) {
            this.filtersAvailable = response.data.icons;
          } else {
            this.filtersAvailable = this.standardIcons();
          }
        })
        .catch((err) => {
          console.log("ERROR: Get ICONS Failed");
          console.log(err);

          this.filtersAvailable = this.standardIcons();
        });
    },

    standardIcons() {
      return {
        nut_coeliacs_flag: false,
        nut_diabetics_flag: false,
        nut_fair_trade_certified_flag: false,
        nut_halal_certified_flag: false,
        nut_kosher_certified_flag: false,
        nut_leaf_certified_flag: false,
        nut_local_certified_flag: false,
        nut_organic_certified_flag: false,
        nut_red_tractor_certified_flag: false,
        nut_uk_certified_flag: false,
        nut_vegans_flag: false,
        nut_vegetarians_flag: false,
      };
    },

    async userSearchProduct() {
      if (this.$refs.searchForm.validate()) {
        this.resetFilters();

        let stringPayload = JSON.stringify({
          userId: this.$store.getters.retrieveUser.userNum,
          sessionKey: this.$store.getters.retrieveUser.sessionKey,
          search: this.search,
          orderDate: this.$store.getters.retrieveCurrentTrolly.order_date,
          customerNo: this.$store.getters.retrieveSelectedCustomer,
        });

        let response = await this.productSearch(stringPayload);

        if (response) {
          this.searchErrors = [];
        } else {
          this.searchErrors.push("Search Error");
        }
      }
    },

    async getFavouriteProducts() {
      this.loadingFavourites = true;
      this.resetFilters();

      let stringPayload = JSON.stringify({
        userId: this.$store.getters.retrieveUser.userNum,
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
        orderDate: this.$store.getters.retrieveCurrentTrolly.order_date,
        customerNo: this.$store.getters.retrieveSelectedCustomer,
      });

      await this.getFavourites(stringPayload);

      this.loadingFavourites = false;
    },

    async getPromotionalProducts() {
      this.loadingPromotions = true;
      this.resetFilters();

      let stringPayload = JSON.stringify({
        userId: this.$store.getters.retrieveUser.userNum,
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
        orderDate: this.$store.getters.retrieveCurrentTrolly.order_date,
        customerNo: this.$store.getters.retrieveSelectedCustomer,
      });

      await this.getPromotions(stringPayload);

      this.loadingPromotions = false;
    },

    async getNewlyAvailableProducts() {
      this.loadingNewProducts = true;
      this.resetFilters();

      let stringPayload = JSON.stringify({
        userId: this.$store.getters.retrieveUser.userNum,
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
        orderDate: this.$store.getters.retrieveCurrentTrolly.order_date,
        customerNo: this.$store.getters.retrieveSelectedCustomer,
      });

      await this.getNewProducts(stringPayload);
      this.loadingNewProducts = false;
    },

    async getGroup(groupNum) {
      this.resetFilters();
      this.showGroups = false;
      this.loadingGroup = true;

      let payload = JSON.stringify({
        userId: this.$store.getters.retrieveUser.userNum,
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
        orderDate: this.$store.getters.retrieveCurrentTrolly.order_date,
        groupNum: groupNum,
      });

      await this.getGroupPriceList({ payload, description: null });

      this.loadingGroup = false;
    },

    async getMandatoryCat() {
      this.resetFilters();
      this.loadingGroup = true;

      await this.getMandatoryCategory();
      this.loadingGroup = false;
    },

    focusSearch() {
      console.log(this.$refs.search);
      this.$refs.search.focus();

      console.log(this.$refs.search);
      //this.$refs.search.$el.select();
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    scrollToSearch() {
      let y = this.$refs.searchTop.offsetTop - 4;
      window.scrollTo(0, y);
    },

    resetFilters() {
      this.distributorFilters = 0;
      this.productFilters = [];
      this.categoryFilters = [];
    },
  },
};
</script>

<style lang="sass" scoped>
*
  word-break: break-word

.v-card__title
  font-size: 16px
  font-weight: bold

.v-card__subtitle
  padding: 4px 1em

.v-item-group.v-bottom-navigation .v-btn
  min-width: 60px
</style>
